

// import React from 'react';
// import { useDrop } from 'react-dnd';

// // Definir estilos de borde para cada tipo de recurso si no está disponible en otro archivo
// const borderStyles = {
//   entity: { borderColor: '#2d3436' },
//   measurement: { borderColor: '#0984e3' },
//   trigger: { borderColor: '#d63031' },
//   delay: { borderColor: '#fdcb6e' },
//   event: { borderColor: '#00b894' },
//   notification: { borderColor: '#6c5ce7' },
// };

// const WorkflowContainer = ({ onDrop, acceptedTypes, droppedItems, onCardClick, onRemoveItem, isLastItem, selections }) => {
//   const [{ isOver }, drop] = useDrop({
//     accept: acceptedTypes,
//     drop: (item) => onDrop(item),
//     collect: (monitor) => ({
//       isOver: monitor.isOver(),
//     }),
//   });

//   return (
//     <div
//       ref={drop}
//       style={{
//         border: '1px solid black',
//         padding: '20px',
//         minHeight: '100px',
//         maxHeight: '600px',
//         overflowY: 'auto',
//         backgroundColor: isOver ? 'lightblue' : 'white',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '10px',
//       }}
//     >
//       {droppedItems.map((item, index) => (
//         <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           <div
//             onClick={() => onCardClick(item)}
//             style={{
//               width: '70%',
//               minWidth: '400px',
//               height: '100px',
//               padding: '15px',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               textAlign: 'center',
//               backgroundColor: '#f8f9fa',
//               border: `2px solid ${selections[item.id] ? 'green' : (borderStyles[item.type]?.borderColor || 'black')}`,
//               boxShadow: selections[item.id] ? '0 0 10px 2px lightgreen' : '0 4px 8px rgba(0,0,0,0.2)',
//               position: 'relative',
//             }}
//           >
//             {selections[item.id] && (
//               <span style={{
//                 position: 'absolute',
//                 top: '5px',
//                 left: '5px',
//                 color: 'green',
//                 fontSize: '20px',
//               }}>✔️</span>
//             )}
//             {item.label}
//             {selections[item.id] && (
//               <div style={{ marginTop: '10px', color: '#555' }}>
//                 Selección: {selections[item.id].visible_name || selections[item.id].name || 'Ninguno'}
//               </div>
//             )}
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onRemoveItem(item);
//               }}
//               disabled={!isLastItem(item)}
//               style={{
//                 position: 'absolute',
//                 top: '5px',
//                 right: '5px',
//                 background: 'red',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '50%',
//                 width: '20px',
//                 height: '20px',
//                 cursor: isLastItem(item) ? 'pointer' : 'not-allowed',
//                 opacity: isLastItem(item) ? 1 : 0.5,
//               }}
//             >
//               &times;
//             </button>
//           </div>
//           {index < droppedItems.length - 1 && (
//             <div style={{ width: '100%', textAlign: 'center', margin: '5px 0' }}>
//               <span style={{ fontSize: '24px', color: '#333' }}>↓</span>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default WorkflowContainer;











import React from 'react';
import { useDrop } from 'react-dnd';

const borderStyles = {
  entity: { borderColor: '#2d3436' },
  measurement: { borderColor: '#0984e3' },
  trigger: { borderColor: '#d63031' },
  delay: { borderColor: '#fdcb6e' },
  event: { borderColor: '#00b894' },
  notification: { borderColor: '#6c5ce7' },
};

const WorkflowContainer = ({ onDrop,elementsList, acceptedTypes, droppedItems, onCardClick, onRemoveItem, isLastItem, selections }) => {
  const [{ isOver }, drop] = useDrop({
    accept: acceptedTypes,
    drop: (item) => onDrop(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });
  return (
    <div
      ref={drop}
      style={{
       
        backgroundColor: isOver ? 'lightblue' : 'var(--white-color)',
      }}
      className='fieldMapElements'
    >
      {droppedItems.map((item, index) => (
        <div key={index} className='rowElementItem'>
          <div
            onClick={() => onCardClick(item)}
            className='contElementItem'
            style={{
             
              border: `2px solid ${elementsList[item.id]? 'lightgreen' :  'var(--border-table-color)'}`,
              boxShadow: elementsList[item.id] ? '0 0 10px 2px lightgreen' : ' 0px 4px 8px rgba(0, 0, 0, 0.1)',
              
            }}
          >
            {/* {elementsList[item.id] && (
              <span style={{
                position: 'absolute',
                top: '5px',
                left: '5px',
                color: 'green',
                fontSize: '20px',
                
              }}>✔️</span>
            )} */}
            {item.label}
            {/* {selections[item.id] && (
              <div style={{ marginTop: '10px', color: '#555' }}>
                Selección: {selections[item.id].visible_name || selections[item.id].name || 'Ninguno'}
              </div>
            )} */}
            <div style={{ marginTop: '10px', color: 'var(--txt-color)',fontSize:'var(--font-size-xSmall)' }}>
                {elementsList[item.id]}
              </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRemoveItem(item);
              }}
              disabled={!isLastItem(item)}
              style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                background: 'red',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '15px',
                height: '15px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: isLastItem(item) ? 'pointer' : 'not-allowed',
                opacity: isLastItem(item) ? 1 : 0.5,
              }}
            >
              &times;
            </button>
          </div>
          {index < droppedItems.length - 1 && (
            <div style={{ width: '100%', textAlign: 'center', margin: '5px 0' ,top:'10%',position:'relative'}}>
              <span style={{ fontSize: '24px', color: '#333' }}>↓</span>
            </div>
          )}
        </div>
      ))}
      <div className='rowElementItem'></div>
    </div>
  );
};

export default WorkflowContainer;
